module.exports = __webpack_public_path__ + "static/media/facebook-messenger.c806635a.svg";